import PropTypes from "prop-types";

export default PropTypes.shape({
  desiredSalary: PropTypes.number,
  editCandidatesLink: PropTypes.string,
  firstName: PropTypes.string,
  jobType: PropTypes.string,
  lastName: PropTypes.string,
  location: PropTypes.string,
  submitToJobLink: PropTypes.string,
  updatedAt: PropTypes.string,
  viewCandidateLink: PropTypes.string,
  viewCvLink: PropTypes.string,
});
